import React, { useState } from "react";
import UIkit from "uikit";
import { Add } from "@carbon/icons-react";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import Constants from "../../../../utils/Constants";
import axios from "axios";
import { DecryptData } from "../../../../utils/Cipher";
import { usePermissions } from "../../../../context/PermissionsContext";


const Transaction = ({ data, id ,refetch ,status }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loader, setLoader] = useState(false);
  const [Transdata, setTransdata] = useState(data);


  const {Permissions} = usePermissions();
  const user = DecryptData();


  const Submit = (data) => {

    setLoader(true);

    axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: data,
      data: { ...data, orderId: id , status:"Paid" },
      url: Constants.url + `payment/create`,
    })
      .then((res) => {
        setLoader(false);

        if (res.data.status === "success") {

          var newdata = res.data.data.transaction
       
          setTransdata([...Transdata, newdata]);

          window
            .swal({
              icon: "success",
              title: "success",
            })
            .then(() => UIkit.modal("#transdialog").hide());
            console.log('Refetching From Transaction')
            refetch()
        }
      })
      .catch((err) => {
        setLoader(false);
        window
          .swal({
            icon: "error",
            title: "Error",
            text: err.response.data.message
          })
      });
  };

  const openModal = () => {
    UIkit.modal("#transdialog").show();
  };

  return (
    <>
      {/* Modal */}

      <div
        id="transdialog"
        container="#pageId"
        uk-modal=""
        style={{ paddingTop: "180px" }}
      >
        <div className="uk-modal-dialog uk-modal-body uk-card uk-card-default uk-card-hover uk-width-large ">
          <button className="uk-modal-close-default" type="button" uk-close>
            X
          </button>

          <h3 className="uk-text-bold uk-text-light">Add </h3>

          <form
            className="uk-form-stacked uk-padding "
            onSubmit={handleSubmit(Submit)}
          >
            {/* <div className="uk-margin-small">
              <label className="uk-form-label" htmlFor="form-username">
                Status
              </label>

              <select
                {...register("status", { required: "Field is required" })}
              >
                <option value="">Select Status</option>{" "}
                <option value="Paid">Paid</option>
                <option value="unPaid">Un-paid</option>
                <option value="refund">Refund</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </div> */}

            <div className="uk-margin-small">
              <label
                className="uk-form-label uk-heading-small"
                htmlFor="form-name"
              >
                Payment Type
              </label>
              <div className="uk-form-controls">
                <select
                  {...register("paymentType", {
                    required: "Field is required",
                  })}
                >
                  <option value="">Select Status</option>{" "}
                  <option value="Dealer">bank via pay order</option>
                  <option value="PayPro">PayPro</option>
                </select>
              </div>
            </div>

            <div className="uk-margin-small">
              <label
                className="uk-form-label uk-heading-small"
                htmlFor="form-name"
              >
                Amount
              </label>
              <div className="uk-form-controls">
                <input
                  {...register("amount", { 
                    required: "Field is required",
                    min: {
                      value: 0,
                      message: "Amount must be non-negative"
                    }
                  })}
                  className="uk-input uk-form-medium"
                  id="form-name"
                  type="number"
                  placeholder="Amount"
                   
                />
              </div>
              <p className="errorMsg">{errors.amount?.message}</p>
            </div>

            <div className="uk-margin-small">
              <labelf Date

                className="uk-form-label uk-heading-small"
                htmlFor="form-name"
              >
                Reference Id
              </labelf>
              <div className="uk-form-controls">
                <input
                  {...register("referenceId", {
                    required: "Field is required",
                  })}
                  className="uk-input uk-form-medium"
                  id="form-name"
                  type="text"
                  placeholder="Reference Id"
                />
              </div>
            </div>

            <div>
              <label
                className="uk-form-label uk-heading-small"
                htmlFor="form-date"
              >
                Date
              </label>
              <div className="uk-form-controls">
                <input
                  {...register("paymentDate", { required: "Field is required" })}
                  className="uk-input uk-form-medium"
                  id="form-date"
                  type="date"
                />
                {errors.date && (
                  <p className="uk-text-danger">{errors.date.message}</p>
                )}
              </div>
            </div>

            <div className="uk-margin-small uk-flex uk-flex-center">
              <button
                className="uk-button uk-button-secondary uk-button-medium uk-width-1-1"
                type="submit"
              >
                {loader ? <div uk-spinner="" className="loader"></div> : "Add"}
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* -------------- */}

      <div className="uk-grid" uk-grid="">
        <div className="uk-width-1-1">
          <div className="analyticsTableWrp ">
            {Permissions?.includes("oms-transaction") && (
            status === 'delivered'  || status === 'cancelled' || status === 'incart' || user.role === 'viewer' ? '': 
            <div className="right">
              <button
                onClick={openModal}
                className="uk-button uk-button-secondary"
              >
                Add <Add size={24} />
              </button>
            </div>
            )}

            <table className="uk-table  uk-table-hover">
              <thead className="dropdownsum">
                <tr>
                  <th>S.No</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Type</th>
                  <th>Payment Date</th>
                </tr>
              </thead>
              <tbody>
                {Transdata.length > 0 ? (
                  Transdata.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>



                      <td>Rs {new Intl.NumberFormat('en-PK', {
                              minimumFractionDigits: 0, 
                              maximumFractionDigits: 0
                              }).format(row.amount || "-")}</td>





                      <td className="entriesBtn">
                        <span style={{ background: row.status === 'Paid' ? 'var(--success)' : 'var(--fail)' }}  >{row.status || "-"}</span>
                      </td>    

                      {/* <td>{row.status || "-"}</td> */}
                      <td>{row.paymentType || "-"}</td>
                      <td>
                        {" "}
                        {row.paymentDate
                          ? new Date(row.paymentDate).toLocaleString("en-US", {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                            hour12: false,
                            timeZone: "Asia/Karachi",
                          })
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td className="uk-text-center" colSpan={5}>
                      {" "}
                      Record Not Found{" "}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Transaction;
